import React from 'react';
import { CheckIcon } from 'lucide-react';
interface WizardStepsProps {
  steps: string[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}
export function WizardSteps({
  steps,
  currentStep,
  onStepClick
}: WizardStepsProps) {
  return <div className="w-full py-4" data-id="element-3462">
      <ol className="flex items-center w-full" data-id="element-3463">
        {steps.map((step, index) => <li key={index} className={`flex items-center ${index < steps.length - 1 ? 'w-full' : 'flex-1'}`} data-id="element-3464">
            <div className={`flex items-center justify-center w-8 h-8 rounded-full lg:h-10 lg:w-10 shrink-0 ${index < currentStep ? 'bg-[#B61C1C] text-white' : index === currentStep ? 'bg-[#B61C1C] text-white' : 'bg-gray-100 text-gray-500'} ${onStepClick ? 'cursor-pointer' : ''}`} onClick={() => onStepClick && onStepClick(index)} data-id="element-3465">
              {index < currentStep ? <CheckIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-3466" /> : <span data-id="element-3467">{index + 1}</span>}
            </div>
            <div className={`flex items-center justify-center w-full ${index < steps.length - 1 ? 'block' : 'hidden'}`} data-id="element-3468">
              <div className={`h-1 w-full ${index < currentStep ? 'bg-[#B61C1C]' : 'bg-gray-200'}`} data-id="element-3469"></div>
            </div>
            <div className={`hidden sm:flex items-center ${index < steps.length - 1 ? 'w-full justify-center' : 'flex-1'}`} data-id="element-3470">
              <span className={`ml-2 text-sm font-medium ${index <= currentStep ? 'text-[#B61C1C]' : 'text-gray-500'} ${onStepClick ? 'cursor-pointer' : ''}`} onClick={() => onStepClick && onStepClick(index)} data-id="element-3471">
                {step}
              </span>
            </div>
          </li>)}
      </ol>
    </div>;
}